module.exports = __webpack_public_path__ + "static/media/i-small.0436b83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/planets/i-small.png
// module id = 1866
// module chunks = 0